module.exports = __webpack_public_path__ + "img/syl_gallery1.9dc48621.jpg";